'use strict';

require('lity/dist/lity');

require('./../sections/collection-carousel/CollectionCarousel');

require('./../sections/featured-nav/FeaturedNav');

require('./../sections/magnet-finder/MagnetFinder');

require('./../sections/recent-searches/RecentSearches');

require('./../sections/testimonial-carousel/TestimonialCarousel');

require('./../sections/usp-bar/USPBar');

require('./../sections/sub-collection/SubCollectionCarousel');